import React from "react";
import { SoftButton } from "../UI/DesignStandards";

const TableFooter = ({
  visibleCount,
  totalCount,
  remainingCount,
  canManageAndLoggedIn,
  verifyingAll,
  onReviewClick,
}) => {
  const showingLabel =
    visibleCount === totalCount
      ? `${totalCount} bowler${totalCount !== 1 ? "s" : ""}`
      : `Showing ${visibleCount} of ${totalCount}`;
  const remainingLabel =
    canManageAndLoggedIn && remainingCount > 0
      ? ` · ${remainingCount} left to verify`
      : "";

  return (
    <div className="px-4 sm:px-6 py-3 border-t border-brand-charcoal/10 bg-brand-cream/60 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="text-sm text-brand-muted">
        {showingLabel}
        {remainingLabel}
      </div>
      {canManageAndLoggedIn && remainingCount > 0 && onReviewClick ? (
        <SoftButton color="gold" size="sm" onClick={onReviewClick}>
          Review ({remainingCount.toLocaleString("en-US")})
        </SoftButton>
      ) : null}
    </div>
  );
};

export default TableFooter;
